import React, { useState } from "react";
// import "./styles.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";
import { useQuery } from "react-query";
import {
  GetGroupsWithSubReportsResponse,
  GroupResponse,
} from "../../../models/pBIReport.model";
import { GetGroup } from "../../../services/pBIReport.service";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Navigation } from 'swiper';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';

export default function Chip({
  group,
  setGroupID,
  groupID,
}: {
  group: GetGroupsWithSubReportsResponse[] | undefined;
  setGroupID: any;
  groupID: number;
}) {

  const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();
  const handleGroupID = (ID: number) => {
    setGroupID(ID);
  };
  const renderSlides = () =>
    group?.map((item, index) => (
      <SwiperSlide>
        <div className="parentChipDashboard">
          <div
            className={`${item.id == groupID ? "chipDashboardFocus" : "chipDashboard"
              }`}
            onClick={() => handleGroupID(item.id)}
          >
            <p style={{ margin: "5px" }}> {item.title}</p>
          </div>
        </div>
      </SwiperSlide>
    ));

  return (
    <div>
      <div style={{ position: "relative" }}>
        <div className="swiper-button image-swiper-button-next image-swiper-button-next-slider">
          <img
            style={{ marginTop: "7px", marginRight: "3px" }}
            src={`images/dashboard/arrow_left_black.png`}
            className="iconeSide"
          />
          {/* <LastPageIcon style={{ color: "#9AAFC4" }} /> */}
        </div>
        <div className="swiper-button image-swiper-button-prev image-swiper-button-prev-slider">
          <img
            style={{ marginTop: "7px" }}
            src={`images/dashboard/arrow_right_black.png`}
            className="iconeSide"
          />
          {/* <FirstPageIcon style={{ color: "#9AAFC4" }} /> */}
        </div>
        <Swiper
          //modules={}
          onSwiper={setSwiperInstance}
          style={{ marginRight: "30px !important", marginLeft: "30px !important" }}
          slidesPerView={3.4}
          centeredSlides
          onSlideChange={(e) => { }}
          initialSlide={1}
          observer={true}
          //navigation={true}
          navigation={{
            nextEl: ".image-swiper-button-next",
            prevEl: ".image-swiper-button-prev",
            disabledClass: "swiper-button-disabled"
          }}
          modules={[Navigation]}
          pagination={true}
        >
          {renderSlides()}
        </Swiper>
      </div>
    </div>
  );
}
